<template>
  <div>
    <div class="pupils-items">
      <figure
        :class="`${value == item.id ? 'active' : ''}`"
        v-for="item in items"
        :key="item.id"
      > 
        <router-link :to="`pupils/${item.id}`">
          <div class="fig-wrapper">
            <div class="num-content">
              {{ item.course.title }} “{{ item.letter }}” 
            </div>
            <div class="desc-content">
              <div>{{item.client_count}} ученика</div>
              <div>{{item.discipline_count}} предметов</div>
            </div>
          </div>
        </router-link>
      </figure>
      <figure
        :class="`${value == item.id ? 'active' : ''}`"
        v-for="item in items"
        :key="item.id"
      > 
        <router-link :to="`pupils/${item.id}`">
          <div class="fig-wrapper">
            <div class="num-content">
              {{ item.course.title }} “{{ item.letter }}” 
            </div>
            <div class="desc-content">
              <div>{{item.client_count}} ученика</div>
              <div>{{item.discipline_count}} предметов</div>
            </div>
          </div>
        </router-link>
      </figure>
      <figure
        :class="`${value == item.id ? 'active' : ''}`"
        v-for="item in items"
        :key="item.id"
      > 
        <router-link :to="`pupils/${item.id}`">
          <div class="fig-wrapper">
            <div class="num-content">
              {{ item.course.title }} “{{ item.letter }}” 
            </div>
            <div class="desc-content">
              <div>{{item.client_count}} ученика</div>
              <div>{{item.discipline_count}} предметов</div>
            </div>
          </div>
        </router-link>
      </figure>
      <figure
        :class="`${value == item.id ? 'active' : ''}`"
        v-for="item in items"
        :key="item.id"
      > 
        <router-link :to="`pupils/${item.id}`">
          <div class="fig-wrapper">
            <div class="num-content">
              {{ item.course.title }} “{{ item.letter }}” 
            </div>
            <div class="desc-content">
              <div>{{item.client_count}} ученика</div>
              <div>{{item.discipline_count}} предметов</div>
            </div>
          </div>
        </router-link>
      </figure>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: function () {
        return [];
      },
    },
    value: {
      default: function () {
        return null;
      },
    },
  },

  methods: {
    // setGroup(id) {
    //   if (id == this.value) {
    //     return false;
    //   }
    //   this.$emit("input", id);
    //   this.$router.push({ query: { group_id: id } });
    // },
    // setNavigate(key) {
    //   this.nav = val;
    //   this.$router.push({ query: { nav: key, group_id: this.value } });
    // },
  },
  data() {
    return {
    };
  },
};
</script>

